import BaseController from "../sharedControllers/BaseController";
import { Routes } from "akademika/akamont/constants/Routes";
import { ServiceDto } from "akademika/akamont/models/ServiceDto";
import JSONModel from "sap/ui/model/json/JSONModel";

/**
 * @namespace akademika.akamont.pages.serviceDetails
 */
export default class ServiceDetails extends BaseController {
  route = Routes.SERVICE_DETAILS;
  parentRoute = Routes.SERVICE_LIST;

  public async onRouteMatched() {
    this.setModel(
      new JSONModel({
        edit: false,
      }),
      "viewOptions"
    );
    await this.refreshServiceDetails();
  }

  public async refreshServiceDetails() {
    this.fetchModel<ServiceDto>("api/Service/GetServiceDetails", undefined, {
      params: { id: this.routeParams.serviceId },
    });
  }

  public async onEditServiceDetails() {
    this.getModel("viewOptions").setProperty("/edit", true);
  }

  public async onCancelEdit() {
    this.getModel("viewOptions").setProperty("/edit", false);
    await this.refreshServiceDetails();
  }

  public async saveServiceDetails() {
    const serviceDetails = this.getModelData<ServiceDto>();

    await this.saveDataAndShowMessage("api/Service/SaveService", {
      body: serviceDetails,
    });

    this.getModel("viewOptions").setProperty("/edit", false);
    this.refreshServiceDetails();
  }
}
